import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { useParams } from "react-router";
import { useQuery } from "@apollo/react-hooks";
import { Button, Loading } from "@atoms";
import { Link } from "react-router-dom";
import { accountUrl } from "@src/app/routes";
import { REFERRAL, SHOP_FOR_INVITE } from "@components/pages/ReferInvitePage/queries";
import { shopForInvite } from "@components/pages/ReferInvitePage/__generated__/shopForInvite";
import { referral } from "@components/pages/ReferInvitePage/__generated__/referral";
import { useAlert } from "react-alert";

const ReferInvitePage: React.FC<IProps> = ({}: IProps) => {
  const {code} = useParams<{code: string}>();
  const alert = useAlert();
  const {data} = useQuery<shopForInvite>(SHOP_FOR_INVITE);
  const {data: dataReferral} = useQuery<referral>(REFERRAL, {variables: {code}});

  return data && dataReferral && (
    <S.Wrapper>
      <p>REFERED BY {dataReferral?.referral?.owner?.firstName} {dataReferral?.referral?.owner?.lastName}</p>
      <p>INVITATION CODE : {code}</p>
      <p>Register now and start referring to earn {data.shop.signupPointAmount} points</p>
      <Link to={`${accountUrl}s/i/${code}/`}>
        <Button>sign up</Button>
      </Link>
    </S.Wrapper>
  ) || <Loading/>
};

export { ReferInvitePage }